import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env?.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env?.VITE_SUPABASE_ANON_KEY;

let client;

if (!supabaseUrl || !supabaseAnonKey) {
  console.error(
    'CRITICAL WARNING: Missing Supabase environment variables. \n' +
    'The application is running in MOCK mode. Backend features will fail gracefully.\n' +
    'Please check your .env file for VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY.'
  );

  // Mock client to prevent app crash
  const mockError = { message: 'Missing Supabase Configuration. Please check .env file.' };
  
  const createMockBuilder = () => ({
    select: () => createMockBuilder(),
    insert: () => createMockBuilder(),
    update: () => createMockBuilder(),
    delete: () => createMockBuilder(),
    eq: () => createMockBuilder(),
    single: async () => ({ data: null, error: mockError }),
    order: async () => ({ data: [], error: mockError }),
    then: (cb) => Promise.resolve({ data: null, error: mockError }).then(cb)
  });

  client = {
    auth: {
      getSession: async () => ({ data: { session: null }, error: null }),
      onAuthStateChange: (callback) => {
        // Immediately invoke with null session to initialize state
        callback('INITIAL_SESSION', null);
        return { data: { subscription: { unsubscribe: () => {} } } };
      },
      signInWithPassword: async () => ({ data: null, error: mockError }),
      signOut: async () => ({ error: null }),
      getUser: async () => ({ data: { user: null }, error: null }),
    },
    from: () => createMockBuilder(),
    rpc: async () => ({ data: null, error: mockError }),
    storage: {
      from: () => ({
        upload: async () => ({ data: null, error: mockError }),
        getPublicUrl: () => ({ data: { publicUrl: '' } })
      })
    }
  };
} else {
  client = createClient(supabaseUrl, supabaseAnonKey, {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
    }
  });
}

export const supabase = client;
